var map = {
	"./banner管理 - 副本.svg": "XNaa",
	"./banner管理.svg": "967m",
	"./dashboard.svg": "BCGP",
	"./example.svg": "OOLB",
	"./eye-open.svg": "no6o",
	"./eye.svg": "4wdf",
	"./form.svg": "sTIr",
	"./icon_form.svg": "xrVx",
	"./link.svg": "KgwQ",
	"./nested.svg": "798r",
	"./password.svg": "QjmH",
	"./table.svg": "oSYw",
	"./tree.svg": "3eCm",
	"./user.svg": "VdD3",
	"./下载中心.svg": "XLpP",
	"./产品支持.svg": "2JH8",
	"./代理商管理.svg": "kAoW",
	"./仪器灰.svg": "2+uu",
	"./仪器管理.svg": "L7l8",
	"./分配账号.svg": "AB3H",
	"./删除.svg": "HL1s",
	"./否.svg": "uhGy",
	"./回访管理.svg": "ZN0F",
	"./宠播社区.svg": "QjtE",
	"./客户接待.svg": "MqIE",
	"./客户管理.svg": "XFjn",
	"./批注.svg": "otde",
	"./报表管理.svg": "GmIW",
	"./接待记录管理.svg": "psmJ",
	"./搜索.svg": "GXxz",
	"./时间.svg": "IAMv",
	"./是.svg": "kmjW",
	"./查看.svg": "rBXJ",
	"./清空.svg": "+Pyk",
	"./用户管理.svg": "qkzt",
	"./系统管理.svg": "6Sh8",
	"./绑定客户.svg": "ulLI",
	"./编辑.svg": "pkiw",
	"./订单管理.svg": "AZ+y",
	"./讲师管理.svg": "trGR",
	"./评论管理.svg": "s6+M",
	"./试剂盘管理.svg": "y2v7",
	"./课程管理.svg": "pGmm",
	"./账户管理.svg": "c16T",
	"./配置管理.svg": "Wylq",
	"./重置密码.svg": "JyZA",
	"./问题管理.svg": "zYvs"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "90Fk";


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg nonrecursive \.svg$
// module id = 90Fk
// module chunks = 26